var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00032 12.173L3.29802 14.8051L4.34824 9.51961L0.391846 5.86087L5.74321 5.22638L8.00032 0.333008L10.2574 5.22638L15.6087 5.86087L11.6524 9.51961L12.7026 14.8051L8.00032 12.173ZM8.00032 10.645L10.8315 12.2297L10.1991 9.04747L12.5812 6.84461L9.35925 6.46257L8.00032 3.51635L6.64135 6.46257L3.41939 6.84461L5.80146 9.04747L5.16914 12.2297L8.00032 10.645Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon03);
export default __webpack_public_path__ + "static/media/sidebar-icon-03.4d3851f8a333a9ec748757c848eb05b9.svg";
export { ForwardRef as ReactComponent };